import React, { useState } from "react";

import { faPlus } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard } from "@performyard/py-components";
import { isValidHexColor } from "@performyard/utils-isomorphic";

import { HexInput } from "./HexInput";

export type ThemeEditorCardProps = {
	mode: "create" | "edit";
	title: string;
	initialBackgroundColor: string;
	isSubmitting: boolean;
	onSubmit: (backgroundColor: string) => void;
	onCancel?: () => void;
};

export const ThemeEditorCard = ({
	mode,
	title,
	initialBackgroundColor,
	isSubmitting,
	onSubmit,
	onCancel,
}: ThemeEditorCardProps) => {
	const [backgroundColor, setBackgroundColor] = useState(initialBackgroundColor);
	const [touched, setTouched] = useState(false);
	const isHexValid = isValidHexColor(backgroundColor);
	const showError = touched && !isHexValid;

	return (
		<div className="box-border flex w-[324px] max-w-full flex-col gap-3 rounded-md border border-solid border-neutral-3 p-4">
			<div className="text-paragraph-3 font-semibold text-neutral-9">{title}</div>
			<div onBlur={() => setTouched(true)}>
				<HexInput value={backgroundColor} onChange={setBackgroundColor} disabled={isSubmitting} />
			</div>
			{showError ? (
				<p className="text-caption text-red-6">Enter a valid 3- or 6-digit hex color, e.g. #153F6F.</p>
			) : null}
			<div className="flex justify-end gap-2">
				{onCancel ? (
					<ButtonStandard
						variant="outline"
						color="neutral"
						size="medium"
						onClick={onCancel}
						disabled={isSubmitting}
						dangerouslySetClassName="w-auto"
					>
						Cancel
					</ButtonStandard>
				) : null}
				<ButtonStandard
					size="medium"
					variant={mode === "edit" ? "outline" : undefined}
					iconLeft={mode === "create" ? faPlus : undefined}
					onClick={() => {
						setTouched(true);
						if (isHexValid) onSubmit(backgroundColor);
					}}
					disabled={isSubmitting || !isHexValid}
					dangerouslySetClassName="w-auto"
				>
					{mode === "create" ? "Create Theme" : "Update Theme"}
				</ButtonStandard>
			</div>
		</div>
	);
};
